// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3T7rO","col":"styles_col__2QB5i","fulfillmentStatus":"styles_fulfillmentStatus__2DrR3","emailCol":"styles_emailCol__3xw6P"};